import React, { useState, useCallback, useEffect } from "react";

import classnames from "classnames";
import isIntuit from "Intuit/isIntuit";

import Button from "Common/Button";
import { Row, Col } from "Common/Grid";
import { Div } from "Common/HTML";

import makeBem from "Utils/makeBem";

const bem = makeBem("Tabs");

/**
 *
 * @param {boolean} scrollableTabNames - when true the Tabs component needs to be used inside a Bootstrap Grid structure (Grid, Card, CardSection, or Col)
 * @returns
 */
const Tabs = ({ children, scrollableTabNames = false }) => {
  const presentChildren = children.filter((child) => !!child);
  const [activeTab, setActiveTab] = useState(presentChildren[0].props.label);
  const handleActiveTab = useCallback((label) => setActiveTab(label), []);
  useEffect(() => {
    if (scrollableTabNames) {
      const activeTabElement = document.querySelector(`.${bem("tab", "active")}`);

      if (activeTabElement) {
        activeTabElement.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }
    }
  }, [activeTab]);
  const tabs = presentChildren.map((child) => (
    <Button
      onClick={() => handleActiveTab(child.props.label)}
      className={
        child.props.label === activeTab
          ? classnames(bem("tab"), bem("tab", "active"), {
              [bem("tab", "active-intuit")]: isIntuit(),
            })
          : classnames(bem("tab"), bem("tab", "inactive"))
      }
      key={child.props.label}
      color="link"
      arial-label={child.props.tabName}
    >
      {child.props.tabName}
    </Button>
  ));
  const tabContent = presentChildren.filter((child) => child.props.label === activeTab);
  return scrollableTabNames ? (
    <Row>
      <Col className={bem("tabBox", "scrollable")}>{tabs}</Col>
      <Col>{tabContent}</Col>
    </Row>
  ) : (
    <Div>
      <div className={classnames(bem("tabBox"))}>{tabs}</div>
      <div>{tabContent}</div>
    </Div>
  );
};

const Tab = (props) => <>{props.children}</>;

export { Tabs, Tab };
